import { render, staticRenderFns } from "./btn-checkbox.vue?vue&type=template&id=92346e44"
import script from "./btn-checkbox.vue?vue&type=script&lang=js"
export * from "./btn-checkbox.vue?vue&type=script&lang=js"
import style0 from "./btn-checkbox.vue?vue&type=style&index=0&id=92346e44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports